export const NO_VALUE: string = "-";
